import { AppConfig } from '../../../common/model/config';
import { northShoppingFortalezaTheme } from '../themes/north-shopping-fortaleza.theme';
import { ORDER_TYPE_TO_GO } from '../../../common/model/order-types';

export const northShoppingFortalezaConfig: AppConfig = {
  appName: 'north-shopping-fortaleza',
  appTitle: 'North Shopping Fortaleza',
  appDescription: 'Peça aqui no North Shopping Fortaleza.',
  aggregator: 1559,
  brand: 1456,
  theme: northShoppingFortalezaTheme,
  faviconPath: '/favicons/favicon-north-shopping.ico',
  defaultOrderType: ORDER_TYPE_TO_GO,
  featureFlags: {
    embeddedApplication: true,
    getBrandThemeFromBackend: false,
    shuffleCompanyArray: true,
    gmapsAddress: false,
    showOptionsTabsAggregators: false,
    filterByDeliveryArea: false,
    useLocalAggregatorHeaderImg: false,
    removeLogoFromTheApp: true,
  },
};
